



import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../services/api";

function EditAgent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  // 🖱️ Mouse Tracking for Background Effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const res = await API.get(`/agents/${id}`);
        setForm(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAgent();
  }, [id]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleUpdate = async () => {
    try {
      await API.put(`/agents/update/${id}`, form);
      alert("✅ Agent Updated Successfully");
    } catch (err) {
      alert("❌ Update failed");
    }
  };

  return (
    <div className="edit-page-wrapper">
      <style>{`
        .edit-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 40px 20px 100px 20px; /* Extra bottom padding for button visibility */
          position: relative;
          overflow-x: hidden;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(251, 191, 36, 0.08) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .edit-container {
          max-width: 1000px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .title {
          font-size: 32px;
          font-weight: 800;
          letter-spacing: -1px;
          margin-bottom: 40px;
          text-align: center;
          background: linear-gradient(to right, #fff, #fbbf24);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .card {
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          padding: 30px;
          margin-bottom: 25px;
          transition: 0.3s;
        }

        .card:hover { border-color: rgba(251, 191, 36, 0.3); }

        .card h3 {
          font-size: 18px;
          color: #fbbf24;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 20px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .input-group label {
          font-size: 12px;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
        }

        .input-group input {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 12px 16px;
          color: white;
          font-size: 14px;
          transition: 0.3s;
        }

        .input-group input:focus {
          outline: none;
          border-color: #fbbf24;
          background: rgba(251, 191, 36, 0.05);
        }

        .save-box {
          position: sticky;
          bottom: 30px;
          display: flex;
          justify-content: center;
          margin-top: 40px;
          z-index: 10;
        }

        .save-btn {
          background: #fbbf24;
          color: #020617;
          border: none;
          padding: 16px 40px;
          border-radius: 16px;
          font-weight: 800;
          font-size: 16px;
          cursor: pointer;
          transition: 0.3s;
          box-shadow: 0 20px 40px rgba(251, 191, 36, 0.2);
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .save-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 25px 50px rgba(251, 191, 36, 0.4);
        }

        /* 📍 BACK BUTTON - LEFT BOTTOM */
        .back-btn-fixed {
          position: fixed;
          bottom: 30px;
          left: 30px;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #94a3b8;
          padding: 12px 20px;
          border-radius: 14px;
          cursor: pointer;
          font-weight: 700;
          z-index: 100;
          transition: 0.3s;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .back-btn-fixed:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
          transform: translateX(5px);
        }

        @media (max-width: 768px) {
          .back-btn-fixed { bottom: 20px; left: 20px; padding: 10px 15px; font-size: 12px; }
          .save-btn { width: 100%; }
        }
      `}</style>

      <div className="spotlight"></div>

      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> Back to Dashboard
      </button>

      <div className="edit-container">
        {/* 🔥 HEADER */}
        <h1 className="title">🚀 Commission Agent Editor</h1>

        {/* 🔥 BASIC INFO */}
        <Section title="Basic Info">
          <Input label="Prev Code" name="prev_code" value={form.prev_code} onChange={handleChange} />

          <Input label="Comm Code" name="comm_code" value={form.comm_code} onChange={handleChange} />
          <Input label="Name" name="name_as_per_pan" value={form.name_as_per_pan} onChange={handleChange} />
          <Input label="DOJ" name="doj" value={form.doj} onChange={handleChange} />
          <Input label="DOB" name="dob" value={form.dob} onChange={handleChange} />
          <Input label="Gender" name="gender" value={form.gender} onChange={handleChange} />
          <Input label="Marital Status" name="marital_status" value={form.marital_status} onChange={handleChange} />
          <Input label="Qualification" name="qualification" value={form.qualification} onChange={handleChange} />
        </Section>

        {/* 🔥 CONTACT */}
        <Section title="Contact">
          <Input label="Mobile" name="mobile_no" value={form.mobile_no} onChange={handleChange} />
          <Input label="Email" name="mail_id" value={form.mail_id} onChange={handleChange} />
        </Section>

        {/* 🔥 IDENTITY */}
        <Section title="Identity">
          <Input label="PAN Card" name="pan_card_no" value={form.pan_card_no} onChange={handleChange} />
          <Input label="Aadhar" name="aadhar_no" value={form.aadhar_no} onChange={handleChange} />
        </Section>

        {/* 🔥 ADDRESS */}
        <Section title="Address">
          <Input label="Permanent Address" name="permanent_address" value={form.permanent_address} onChange={handleChange} />
          <Input label="Current Address" name="current_address" value={form.current_address} onChange={handleChange} />
        </Section>

        {/* 🔥 JOB INFO */}
        <Section title="Job Info">
          <Input label="Payout" name="payout" value={form.payout} onChange={handleChange} />
          <Input label="Designation" name="designation" value={form.designation} onChange={handleChange} />
          <Input label="State" name="state" value={form.state} onChange={handleChange} />
          <Input label="Office Location" name="office_location" value={form.office_location} onChange={handleChange} />
          <Input label="Place of Posting" name="place_of_posting" value={form.place_of_posting} onChange={handleChange} />
          <Input label="Portfolio" name="portfolio" value={form.portfolio} onChange={handleChange} />
        </Section>

        {/* 🔥 BANK */}
        <Section title="Bank Details">
          <Input label="Name as per Bank" name="name_as_per_bank" value={form.name_as_per_bank} onChange={handleChange} />
          <Input label="Account Number" name="account_number" value={form.account_number} onChange={handleChange} />
          <Input label="Bank Name" name="bank_name" value={form.bank_name} onChange={handleChange} />
          <Input label="IFSC Code" name="ifsc_code" value={form.ifsc_code} onChange={handleChange} />
        </Section>

        {/* 🔥 INTERNAL */}
        <Section title="Internal">
          <Input label="Cost Centre" name="cost_centre" value={form.cost_centre} onChange={handleChange} />
          <Input label="KAM" name="kam" value={form.kam} onChange={handleChange} />
          <Input label="TL" name="tl" value={form.tl} onChange={handleChange} />
          <Input label="SM" name="sm" value={form.sm} onChange={handleChange} />
          <Input label="BOH" name="boh" value={form.boh} onChange={handleChange} />
        </Section>

        {/* 🔥 FAMILY */}
        <Section title="Family">
          <Input label="Father Name" name="fathers_name" value={form.fathers_name} onChange={handleChange} />
          <Input label="Father DOB" name="fathers_dob" value={form.fathers_dob} onChange={handleChange} />
          <Input label="Mother Name" name="mothers_name" value={form.mothers_name} onChange={handleChange} />
          <Input label="Mother DOB" name="mothers_dob" value={form.mothers_dob} onChange={handleChange} />
          <Input label="Spouse Name" name="spouse_name" value={form.spouse_name} onChange={handleChange} />
          <Input label="Spouse DOB" name="spouse_dob" value={form.spouse_dob} onChange={handleChange} />
        </Section>

        {/* 🔥 CHILDREN */}
        <Section title="Children">
          <Input label="Child 1 Name" name="child1_name" value={form.child1_name} onChange={handleChange} />
          <Input label="Child 1 DOB" name="child1_dob" value={form.child1_dob} onChange={handleChange} />
          <Input label="Child 1 Gender" name="child1_gender" value={form.child1_gender} onChange={handleChange} />

          <Input label="Child 2 Name" name="child2_name" value={form.child2_name} onChange={handleChange} />
          <Input label="Child 2 DOB" name="child2_dob" value={form.child2_dob} onChange={handleChange} />
          <Input label="Child 2 Gender" name="child2_gender" value={form.child2_gender} onChange={handleChange} />
        </Section>

        {/* 🔥 EXTRA */}
        <Section title="Other">
          <Input label="Remarks" name="remarks" value={form.remarks} onChange={handleChange} />
          <Input label="Last Working Date" name="lwd" value={form.lwd} onChange={handleChange} />
          <Input label="Mail By" name="mail_by" value={form.mail_by} onChange={handleChange} />
          <Input label="DRA Status" name="dra_status" value={form.dra_status} onChange={handleChange} />
        </Section>

        {/* 🔥 SAVE BUTTON */}
        <div className="save-box">
          <button className="save-btn" onClick={handleUpdate}>
            💾 Update Agent Profile
          </button>
        </div>
      </div>
    </div>
  );
}

const Section = ({ title, children }) => (
  <div className="card">
    <h3>{title}</h3>
    <div className="grid">{children}</div>
  </div>
);

const Input = ({ label, name, value, onChange }) => (
  <div className="input-group">
    <label>{label}</label>
    <input name={name} value={value || ""} onChange={onChange} autoComplete="off" />
  </div>
);

export default EditAgent;

